import script from "./WatchlistMetrics.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchlistMetrics.vue?vue&type=script&setup=true&lang=js"

import "./WatchlistMetrics.vue?vue&type=style&index=0&id=5723011e&lang=scss"

const __exports__ = script;

export default __exports__